import { render, staticRenderFns } from "./sso-index.vue?vue&type=template&id=690a0ee9&scoped=true"
import script from "./sso-index.vue?vue&type=script&lang=js"
export * from "./sso-index.vue?vue&type=script&lang=js"
import style0 from "./sso-index.vue?vue&type=style&index=0&id=690a0ee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a0ee9",
  null
  
)

export default component.exports